<template>
  <div>
    <!-- 化化自建房服务 -->
    <section id="img-0" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/productBg.png')">
      <div class="img-0-wrap">
        <div class="img0-content">
          <h2 class="img0-title">
            <span>化化自建房服务</span>
          </h2>
          <p class="img0-desc">
            <span>用工程级标准，守护你的百年宅</span>
            <span>从图纸到入住，先装后付、平台托底、在线验收 | 24年工程经验 · 鲁班奖团队技术支持</span>
          </p>
        </div>
        <img class="img0-img img0-qrcode" src="https://obs.huahuaeco.com/official/qrcode.png" alt="扫码体验小程序与关注官方服务号">
      </div>
    </section>

    <!-- 自建房业主的四大难题 -->
    <section id="img-2">
      <div class="img2-content">
        <h2 class="img2-title">自建房业主的四大难题</h2>
        <p class="img2-subtitle">农村建房，为什么总是“提心吊胆”？</p>

        <div class="img2-grid">
          <article class="img2-card img2-card-lt">
            <h3>没标准</h3>
            <p>没有规范图纸和统一工艺标准，全凭师傅口头经验，质量好坏全看运气，心里没底</p>
          </article>

          <article class="img2-card img2-card-rt">
            <h3>没人管</h3>
            <p>自己不懂行，又没法天天盯着工地；施工方偷工减料，等发现时木已成舟，收拾难改</p>
          </article>

          <div class="img2-center" aria-hidden="true">
            <img src="https://obs.huahuaeco.com/official/selfBuildQuestion.png" alt="" />
          </div>

          <article class="img2-card img2-card-lb">
            <h3>钱难控</h3>
            <p>付款节奏不清晰，材料人工一笔糊涂账；包工头动不动就临时加钱，不给就停工，骑虎难下</p>
          </article>

          <article class="img2-card img2-card-rb">
            <h3>没售后</h3>
            <p>房子一建完成工队就消失，墙面开裂、屋顶漏水、地基下沉，连个负责的人都找不到</p>
          </article>
        </div>
      </div>
    </section>

    <!-- 平台交易保障 -->
    <section id="img-3">
      <div class="img3-content">
        <h2 class="img3-title">化化平台四大核心保障机制</h2>
        <p class="img3-subtitle">我们把“鲁班奖工程”的管理标准，用在了你的家</p>

        <div class="img3-grid">
          <article class="img3-card img3-card-lt">
            <h3>先建后付，资金托管</h3>
            <p>建房款不直接给施工方，由平台与第三方支付机构联合托管，按地基、主体、封顶、竣工等节点验收，满意才付款，你家的钱，你做主</p>
          </article>

          <article class="img3-card img3-card-rt">
            <h3>在线验收，过程透明</h3>
            <p>每个关键节点（地基、主体、水电等）需上传影像，业主通过小程序对照标准清单在线确认，不合格打回整改，人在外地，也能实时监工</p>
          </article>

          <div class="img3-center" aria-hidden="true">
            <img src="https://obs.huahuaeco.com/official/Product/img5safe.png" alt="" />
          </div>

          <article class="img3-card img3-card-lb">
            <h3>平台托底，售后无忧</h3>
            <p>施工方跑路或严重违约，平台协调团队接手，不烂尾、不加价，额外费用平台先行承担，平台给你最后一道保障</p>
          </article>

          <article class="img3-card img3-card-rb">
            <h3>严选队伍，匠心筑家</h3>
            <p>施工队需通过资质审核、在线考核、业主评价三重筛选，每支队伍都有公开的“数字画像”，好手艺、好服务，用数据说话</p>
          </article>
        </div>
      </div>
    </section>

    <!-- 服务流程 -->
    <section id="img-4">
      <div class="img4-content">
        <h2 class="img4-title">服务流程</h2>
        <p class="img4-subtitle">从发布需求到竣工交付，全程线上留痕，手机就能搞定</p>

        <div class="img4-panel">
          <article class="img4-step" v-for="(step, index) in serviceSteps" :key="step.title">
            <div class="img4-step-index">{{ String(index + 1).padStart(2, '0') }}</div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- 立即体验 -->
    <section id="img-7" class="full-image img7-section">
      <div class="img7-title1">立即体验</div>
      <div class="img7-title2">我们致力于服务至业主满意为止，不负每个客户的信任</div>

      <img class="img7-img" src="https://obs.huahuaeco.com/official/selfBuildServier.png" alt="">
    </section>

    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { getPageHead } from '../utils/page-head'
import SeoStaticImages from '../components/SeoStaticImages.vue'
export default {
  name: 'ProductPage',
  components: {
    SeoStaticImages
  },
    setup() {
    useHead(getPageHead('selfBuildServices'))
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/productBg.png',
        'https://obs.huahuaeco.com/official/qrcode.png',
        'https://obs.huahuaeco.com/official/selfBuildQuestion.png',
        'https://obs.huahuaeco.com/official/Product/img5safe.png',
        'https://obs.huahuaeco.com/official/selfBuildServier.png'
      ],
      imgList: [
        { url: 'https://obs.huahuaeco.com/official/Product/img1e.png', alt: '专属定制，帮您设计理想家', msg: '提供全流程设计服务，为您的理想家保驾护航', 
          tags: ['图纸设计','造价清单','选材建议','施工跟进','摆场指导']
        },
        { url: 'https://obs.huahuaeco.com/official/Product/img2e.png', alt: '师傅手艺好，干活不马虎', msg: '我们严选经验扎实的师傅团队，从细节到整体，把靠谱落到实处',
          tags: ['拆除工','水电工','泥瓦工','油漆工','木工']
         },
        { url: 'https://obs.huahuaeco.com/official/Product/img3e.png', alt: '自营装企，全程兜底，安心不用盯', msg: '我们以自营模式把控装修全流程，让您告别 “盯工地” 的疲惫',
          tags: ['客户至上','不主动增项','在线签约','规范施工','满意为止']
        },
      ],
      serviceSteps: [
        { title: '发布需求', desc: '在线提交建房意向' },
        { title: '免费量房/勘测', desc: '专业人员上门勘测' },
        { title: '方案与报价', desc: '提供设计方案+详细预算清单' },
        { title: '确认下单', desc: '确认报价方案后下单' },
        { title: '签约与托管金额', desc: '签约后，分阶段托管建房款' },
        { title: '施工交付', desc: '按节点、严标准施工' },
        { title: '节点与竣工验收', desc: '按节点在线验收' },
        { title: '售后保障', desc: '按约定享受售后服务' }
      ],
      img6Active: 'left',
      showFooter: true
    }
  },
  methods: {
    setImg6(side) {
      this.img6Active = side
    },
    handleScroll() {
      const img6 = document.getElementById('img-6')
      if (!img6) {
        this.showFooter = true
        return
      }
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || window.scrollY || 0
      const img6Top = img6.getBoundingClientRect().top + scrollY
      // 当滚动到 img-6 的顶部或更低位置时，隐藏页脚
      this.showFooter = scrollY < img6Top - 500
    }
  }
  ,
  mounted() {
    this.handleScroll()
    this._boundHandleScroll = this.handleScroll.bind(this)
    window.addEventListener('scroll', this._boundHandleScroll, { passive: true })
  },
  beforeUnmount() {
    if (this._boundHandleScroll) {
      window.removeEventListener('scroll', this._boundHandleScroll)
    }
  }
}
</script>

<style scoped lang="scss">
.img-6-wrap {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  img {
    width: 80%;
    height: auto;
    display: block;
  }
}

.img6-section {
  position: relative;
  min-height: 86vh;
  background-size: cover;
  background-position: center center;
  display: block;
  transition: background-image 0.4s ease, background-position 0.4s ease;
  padding-top: 60px;
  .img6-title1 {
    color: #262626;
    text-align: center;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .img6-title2 {
    color: #595959;
    text-align: center;
    font-size: 24px;
  }
}

.img6-toggle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 25%;
  z-index: 95;
  display: flex;
  pointer-events: auto;
}

.img6-btn {
  width: 188px;
  height: 72px;
  background: transparent;
  border: 0;
  opacity: 0;
  cursor: pointer;
}

.img7-section {
  padding-top: 100px;
  .img7-title1 {
    color: #262626;
    text-align: center;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .img7-title2 {
    color: #595959;
    text-align: center;
    font-size: 24px;
  }
}

#img-7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 0 !important;
  min-height: 80vh !important;
  height: 8rem;
}
.img7-img {
  width: 6.6667rem;
  margin-top: 60px;
}

#img-2 {
  position: relative;
  padding: 88px 24px 96px;
  background:
    radial-gradient(circle at top, rgba(225, 237, 250, 0.95) 0%, rgba(245, 248, 252, 0.92) 35%, #ffffff 78%),
    linear-gradient(180deg, #f5f8fc 0%, #ffffff 100%);
  overflow: hidden;
}

.img2-content {
  width: min(1220px, 100%);
  margin: 0 auto;
}

.img2-title {
  margin: 0;
  text-align: center;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.25;
}

.img2-subtitle {
  margin: 24px 0 0;
  text-align: center;
  color: #8c8c8c;
  font-size: 24px;
  line-height: 1.5;
}

.img2-grid {
  margin-top: 72px;
  display: grid;
  grid-template-columns: minmax(260px, 1fr) minmax(240px, 360px) minmax(260px, 1fr);
  grid-template-areas:
    "lt center rt"
    "lb center rb";
  column-gap: clamp(28px, 4vw, 72px);
  row-gap: 28px;
  align-items: center;
}

.img2-card-lt { grid-area: lt; }
.img2-card-rt { grid-area: rt; }
.img2-card-lb { grid-area: lb; }
.img2-card-rb { grid-area: rb; }

.img2-card {
  min-height: 146px;
  padding: 28px 30px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 18px 50px rgba(56, 89, 126, 0.08);
  backdrop-filter: blur(12px);

  h3 {
    margin: 0;
    color: #3a3a3a;
    font-size: 28px;
    font-weight: 600;
    line-height: 1.35;
  }

  p {
    margin: 18px 0 0;
    color: #8c8c8c;
    font-size: 16px;
    line-height: 1.8;
  }
}

.img2-center {
  grid-area: center;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: min(100%, 360px);
    height: auto;
    display: block;
  }
}

#img-3 {
  position: relative;
  padding: 96px 24px 104px;
  background:
    radial-gradient(circle at top, rgba(228, 237, 247, 0.95) 0%, rgba(246, 248, 252, 0.94) 34%, #ffffff 80%),
    linear-gradient(180deg, #f6f9fd 0%, #ffffff 100%);
  overflow: hidden;
}

.img3-content {
  width: min(1280px, 100%);
  margin: 0 auto;
}

.img3-title {
  margin: 0;
  text-align: center;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.25;
}

.img3-subtitle {
  margin: 24px 0 0;
  text-align: center;
  color: #8c8c8c;
  font-size: 24px;
  line-height: 1.5;
}

.img3-grid {
  margin-top: 72px;
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(260px, 380px) minmax(280px, 1fr);
  grid-template-areas:
    "lt center rt"
    "lb center rb";
  column-gap: clamp(28px, 4.4vw, 76px);
  row-gap: 28px;
  align-items: center;
}

.img3-card-lt { grid-area: lt; }
.img3-card-rt { grid-area: rt; }
.img3-card-lb { grid-area: lb; }
.img3-card-rb { grid-area: rb; }

.img3-card {
  min-height: 146px;
  padding: 28px 30px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 18px 50px rgba(56, 89, 126, 0.08);
  backdrop-filter: blur(12px);

  h3 {
    margin: 0;
    color: #3a3a3a;
    font-size: 28px;
    font-weight: 600;
    line-height: 1.35;
  }

  p {
    margin: 18px 0 0;
    color: #8c8c8c;
    font-size: 16px;
    line-height: 1.8;
  }
}

.img3-center {
  grid-area: center;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: min(100%, 420px);
    height: auto;
    display: block;
  }
}

#img-4 {
  padding: 96px 24px 104px;
  background:
    radial-gradient(circle at top, rgba(227, 236, 247, 0.95) 0%, rgba(245, 248, 252, 0.92) 34%, #ffffff 82%),
    linear-gradient(180deg, #f5f8fc 0%, #ffffff 100%);
}

.img4-content {
  width: min(1220px, 100%);
  margin: 0 auto;
}

.img4-title {
  margin: 0;
  text-align: center;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.25;
}

.img4-subtitle {
  margin: 24px 0 0;
  text-align: center;
  color: #8c8c8c;
  font-size: 24px;
  line-height: 1.5;
}

.img4-panel {
  margin-top: 72px;
  padding: 52px 56px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 20px 60px rgba(56, 89, 126, 0.08);
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 36px;
  row-gap: 48px;
}

.img4-step {
  text-align: center;

  h3 {
    margin: 24px 0 0;
    color: #2f2f2f;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.35;
  }

  p {
    margin: 16px 0 0;
    color: #8c8c8c;
    font-size: 16px;
    line-height: 1.7;
  }
}

.img4-step-index {
  width: 44px;
  height: 44px;
  margin: 0 auto;
  border-radius: 50%;
  background: linear-gradient(180deg, #7ec0ff 0%, #5da8ff 100%);
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  line-height: 44px;
  box-shadow: 0 10px 22px rgba(93, 168, 255, 0.24);
}

#img-5 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background-position: center;
}

#img-0 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: auto !important;
  min-height: 360px;
  padding: 180px 24px 90px;
  box-sizing: border-box;
}

.img-0-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0;
  .img0-content {
    text-align: center;
  }
  .img0-img {
    width: 6.6667rem;
    margin-top: 60px;
  }
  .img0-qrcode {
    width: min(9rem, 82vw);
    height: auto;
  }
  .img0-title {
    margin: 0;
    color: #262626;
    font-size: 48px;
    font-weight: 600;
    line-height: 1.35;

    span {
      display: block;
    }
  }

  .img0-desc {
    margin: 34px 0 0;
    color: #595959;
    font-size: 20px;
    line-height: 1.8;

    span {
      display: block;
    }
  }
}

.img5-content {
  width: min(1220px, 100%);
  margin: 0 auto;
}

.img5-title {
  margin: 0;
  text-align: center;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.25;
}

.img5-subtitle {
  margin: 24px 0 0;
  text-align: center;
  color: #8c8c8c;
  font-size: 24%;
  line-height: 1.45;
  font-size: 24px;
}

.img5-grid {
  margin-top: 66px;
  display: grid;
  grid-template-columns: minmax(280px, 1fr) 300px minmax(280px, 1fr);
  grid-template-areas:
    "lt center rt"
    "lb center rb";
  align-items: center;
  column-gap: clamp(24px, 3.8vw, 56px);
  row-gap: 36px;
}

.img5-card-lt { grid-area: lt; }
.img5-card-rt { grid-area: rt; }
.img5-card-lb { grid-area: lb; }
.img5-card-rb { grid-area: rb; }

.img5-card {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 34px 30px;

  h3 {
    margin: 0;
    color: #3a3a3a;
    font-size: 22px;
    line-height: 1.35;
  }

  p {
    margin: 18px 0 0;
    color: #8c8c8c;
    font-size: 16px;
    line-height: 1.55;
  }
}

.img5-center {
  grid-area: center;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    max-width: 360px;
    height: auto;
    display: block;
  }

  
}

@media (max-width: 1300px) {
  #img-0 {
    padding: 120px 40px 90px;
  }

  #img-2 {
    padding: 72px 24px 80px;
  }

  .img2-title {
    font-size: 40px;
  }

  .img2-subtitle {
    font-size: 20px;
  }

  .img2-grid {
    margin-top: 56px;
    grid-template-columns: minmax(220px, 1fr) minmax(220px, 300px) minmax(220px, 1fr);
    column-gap: 20px;
    row-gap: 20px;
  }

  .img2-card {
    padding: 22px 24px;

    h3 {
      font-size: 24px;
    }
  }

  #img-3 {
    padding: 80px 24px 88px;
  }

  .img3-title {
    font-size: 40px;
  }

  .img3-subtitle {
    font-size: 20px;
  }

  .img3-grid {
    margin-top: 56px;
    grid-template-columns: minmax(220px, 1fr) minmax(220px, 320px) minmax(220px, 1fr);
    column-gap: 20px;
    row-gap: 20px;
  }

  .img3-card {
    padding: 22px 24px;

    h3 {
      font-size: 24px;
    }
  }

  #img-4 {
    padding: 80px 24px 88px;
  }

  .img4-title {
    font-size: 40px;
  }

  .img4-subtitle {
    font-size: 20px;
  }

  .img4-panel {
    margin-top: 56px;
    padding: 40px 32px;
    column-gap: 24px;
    row-gap: 40px;
  }

  .img5-center {
    img {
      max-width: 240px;
    }
  }
  .img5-card {
    padding: 10px 10px;
  }
  .img5-grid {
    column-gap: 12px;
    grid-template-columns: minmax(280px, 1fr) 180px minmax(280px, 1fr)
  }
}

@media (max-width: 1600px) {
}

@media (max-width: 1100px) {
  #img-0 {
    padding: 96px 28px 72px;
  }

  #img-2 {
    padding: 64px 20px 72px;
  }

  .img2-title {
    font-size: 32px;
  }

  .img2-subtitle {
    margin-top: 18px;
    font-size: 18px;
  }

  .img2-grid {
    margin-top: 40px;
    grid-template-columns: 1fr;
    grid-template-areas:
      "center"
      "lt"
      "rt"
      "lb"
      "rb";
  }

  .img2-center {
    margin-bottom: 8px;

    img {
      width: min(72vw, 300px);
    }
  }

  .img2-card {
    min-height: auto;
    padding: 22px 20px;

    h3 {
      font-size: 22px;
    }

    p {
      margin-top: 12px;
      font-size: 15px;
      line-height: 1.7;
    }
  }

  #img-3 {
    padding: 64px 20px 72px;
  }

  .img3-title {
    font-size: 32px;
  }

  .img3-subtitle {
    margin-top: 18px;
    font-size: 18px;
  }

  .img3-grid {
    margin-top: 40px;
    grid-template-columns: 1fr;
    grid-template-areas:
      "center"
      "lt"
      "rt"
      "lb"
      "rb";
  }

  .img3-center {
    margin-bottom: 8px;

    img {
      width: min(72vw, 320px);
    }
  }

  .img3-card {
    min-height: auto;
    padding: 22px 20px;

    h3 {
      font-size: 22px;
    }

    p {
      margin-top: 12px;
      font-size: 15px;
      line-height: 1.7;
    }
  }

  #img-4 {
    padding: 64px 20px 72px;
  }

  .img4-title {
    font-size: 32px;
  }

  .img4-subtitle {
    margin-top: 18px;
    font-size: 18px;
  }

  .img4-panel {
    margin-top: 40px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 28px 20px;
    column-gap: 18px;
    row-gap: 28px;
  }

  .img4-step {
    h3 {
      margin-top: 18px;
      font-size: 20px;
    }

    p {
      margin-top: 12px;
      font-size: 15px;
    }
  }

  .img4-step-index {
    width: 40px;
    height: 40px;
    font-size: 18px;
    line-height: 40px;
  }
}

@media (max-width: 640px) {
  .img4-panel {
    grid-template-columns: 1fr;
  }
}
</style>
